export function deriveHubConnected(
  orgDocument: { appTargetUrls?: { appName: string }[] } | null | undefined,
): boolean {
  return !!orgDocument?.appTargetUrls?.some((app) => app?.appName === 'hub');
}
